export default __webpack_public_path__ + "static/media/icon_like-2.40706a15.svg";